import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router';

interface BackButtonProps {
  fallback?: string;
}

export const BackButton = ({ fallback }: BackButtonProps) => {
  const navigate = useNavigate();

  const handle = (e: React.MouseEvent) => {
    e.stopPropagation();

    // try to use history.back if a previous entry exists
    const histState = window.history.state;

    if (histState && histState.idx && typeof histState.idx === 'number' && histState.idx > 1) {
      // If the history state index is greater than 1
      navigate(-1);

      return;
    }

    if (fallback) {
      navigate(`/${fallback}`);
    }
  };

  return (
    <Button startIcon={<ArrowBackIcon />} onClick={handle} size='small' variant='text'>
      Back
    </Button>
  );
};
